import type { QueryKey, UseQueryOptions } from '@tanstack/vue-query'
import { useQuery as _useQuery } from '@tanstack/vue-query'

export function useQuery<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey
>(options: Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, 'initialData'> & {
    initialData?: () => undefined
    queryKey: TQueryKey
    queryFn: () => Promise<TQueryFnData>
    enabled?: boolean
}) {
    // @ts-expect-error idk
    return _useQuery<TQueryFnData, TError, TData, TQueryKey>({
        ...options,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    })
}
